<template>
  <div class="no-permission-wrapper">
    <span :id="id" tabindex="0">
      <slot />
      <no-permission-tooltip v-if="show" :target="id" />
    </span>
  </div>
</template>

<script>
import NoPermissionTooltip from "./NoPermissionTooltip.vue";

export default {
  name: "NoPermissionWrapper",
  components: {NoPermissionTooltip},
  props: {
    show: Boolean
  },
  data() {
    return {
      id: this.makeId(10),
    }
  },
  methods: {
    makeId(length) {
      let result = '',
          characters = 'abcdefghijklmnopqrstuvwxyz',
          charactersLength = characters.length;
      for (let i = 0; i < length; i++) {
        result += characters.charAt(Math.floor(Math.random() * charactersLength));
      }

      return result;
    }
  }
}
</script>

<style lang="scss" scoped>
.no-permission-wrapper {
  display: inline-block;
}
</style>
